import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./White_Btn.css";

const White_Btn = ({
  onClick,
  leftIcon,
  btnText,
  rightIcon,
  type = "button",
}) => {
  return (
    <button className="White_Outline_Btn" onClick={onClick} type={type}>
      {leftIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={leftIcon} className="left_icon" />
        </div>
      )}

      <p className="btn_text">{btnText}</p>

      {rightIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={rightIcon} className="right_icon" />
        </div>
      )}
    </button>
  );
};

export default White_Btn;
